import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import "./planogram_components.css";
import { Collapse, Stack } from "@mui/material";
import ColorPicker from './color_picker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useDispatch, useSelector } from "react-redux";
import { analysisActions } from "../../store/store";

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgb(61,162,131)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgb(61,162,131)",
    maxWidth: "7rem"
  },
}));

export default function Selector(props) {
  const { baseColor, value, type, removeDisabled } = props;
  const dispatch = useDispatch();

  const changeColor = (e) => {
   props.onChange([type, e.color]) 
  }

  const handleRemoveItem = () => {
    props.onClick(type)
  }

  return (
    <Stack 
      direction="row"
      spacing={2}
      className="selector"
    >
      <BootstrapTooltip title={`${type}`} placement="top">
        <span className="selector-text">{type}</span>
      </BootstrapTooltip>
      {!removeDisabled && <FontAwesomeIcon 
        className="selector-icon" 
        icon={faXmark} 
        onClick={handleRemoveItem}
      />}
      <ColorPicker
        type="ai-boxes"
        color={!baseColor ? "rgba(0, 255, 179, 1)" : baseColor}
        changeColor={changeColor}
      />
    </Stack>
  );
}
